import queryClient, { IQueryParams } from 'queries';
import helpers from 'helpers/index';
import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { TypedTicket } from './ticket.query';
import { TypedTripManifest } from './trip_manifest.query';




export interface TypedTrip_manifest_ticket {
    id?: string;
    trip_manifest_id?: string;
    ticket_id?: string;
    seat_position?: string;
    createdAt?: string;
    ticket?: TypedTicket;
    trip_manifest?: TypedTripManifest,
}

type IQuery = TypedTrip_manifest_ticket & IQueryParams;


/*
* List of all trip manifest
*/
export function useGetTrip_manifest_ticket(object: IQuery) {
    const EndURL = helpers.buildEndUrl(object);
    return useQuery({
        queryKey: ["trip_manifest_ticket/fetch_entity_list", object],
        queryFn: () => axios.get<TypedTrip_manifest_ticket[]>(`/trip_manifest_ticket/${EndURL}`).then(response => response.data),
        retry: 1,
        enabled: !!object.trip_manifest_id,
    });
}



export function useMutateUpdate_ticket_position() {
    return useMutation({
        mutationKey: ['trip_manifest_ticket/update_ticket_position'],
        mutationFn: (body: { trip_manifest_ticket_id: string, seat_position: string, trip_manifest_id: any }) => axios.post<any>(`/trip_manifest_ticket/update_ticket_position`, body).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['trip/fetch_entity'] });
            queryClient.invalidateQueries({ queryKey: ['trip_manifest/fetch_entity'] });
            queryClient.invalidateQueries({ queryKey: ['trip_manifest_ticket/fetch_entity_list'] });
        }
    });
}


/** Xóa vé đi  */
export function useMutateRemove_ticket_from_trip() {
    return useMutation({
        mutationKey: ['trip_manifest_ticket/delete_entity'],
        mutationFn: (trip_manifest_ticket_id: string) => axios.delete<any>(`/trip_manifest_ticket/${trip_manifest_ticket_id}`).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['trip/fetch_entity'] });
            queryClient.invalidateQueries({ queryKey: ['trip_manifest/fetch_entity'] });
            queryClient.invalidateQueries({ queryKey: ['trip_manifest_ticket/fetch_entity_list'] });

        }
    });
}


/** Khối thêm vé vào chuyến  */
export function useMutateAdd_ticket_to_trip() {
    return useMutation({
        mutationKey: ['trip_manifest_ticket/create_entity'],
        mutationFn: (body: { trip_manifest_id: any, ticket_id: string, seat_position?: string }) => axios.post(`/trip_manifest_ticket`, body).then((response) => response.data),
        onSuccess: () => {
            /** Load lại trip */
            queryClient.invalidateQueries({ queryKey: ['trip/fetch_entity'] });
            queryClient.invalidateQueries({ queryKey: ['trip_manifest/fetch_entity'] });
            queryClient.invalidateQueries({ queryKey: ['trip_manifest_ticket/fetch_entity_list'] });

        }
    });
}


/** Di chuyển vé sang một trip mới */
export function useMutateMoving_ticket_to_trip() {
    return useMutation({
        mutationKey: ['trip_manifest_ticket/moving_entity'],
        mutationFn: (body: { trip_manifest_id: string | bigint, ticket_id?: string | bigint, seat_position?: string }) => axios.patch(`/trip_manifest_ticket/moving_ticket_to_other_trip_manifest`, body).then((response) => response.data),
        onSuccess: () => {
            /** Load lại trip */
            queryClient.invalidateQueries({ queryKey: ['trip/fetch_entity'] });
            queryClient.invalidateQueries({ queryKey: ['trip_manifest/fetch_entity'] });
            queryClient.invalidateQueries({ queryKey: ['trip_manifest_ticket/fetch_entity_list'] });

        }
    });
}


